import { Link } from "react-router-dom";
import { Heart, Instagram } from "lucide-react";

const _NO_SUPPORT_EMAIL = ""; // support email removed at branding request

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-amber-100 bg-white/70 relative z-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-1 md:grid-cols-5 gap-8">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2 mb-3" data-testid="footer-logo">
            <img src="/logo.png" alt="Junior Shelf logo" className="h-12 w-auto object-contain" />
            <div className="font-display text-lg font-semibold text-slate-900">Junior Shelf</div>
          </Link>
          <p className="text-sm text-slate-600 leading-relaxed max-w-sm">
            A shared digital shelf for every book in your home. Lend what you've outgrown,
            borrow the next great read from a neighbour — kids' books and grown-up ones alike.
          </p>
          <div className="flex items-center gap-1 text-xs text-slate-500 mt-4">
            Made with <Heart size={12} className="text-rose-500" fill="currentColor" strokeWidth={0} /> in Gurgaon, India
          </div>
        </div>

        <div>
          <div className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-3">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/browse" className="text-slate-700 hover:text-orange-600" data-testid="footer-browse">Browse books</Link></li>
            <li><Link to="/map" className="text-slate-700 hover:text-orange-600" data-testid="footer-map">Explore map</Link></li>
            <li><Link to="/list" className="text-slate-700 hover:text-orange-600" data-testid="footer-list">List a book</Link></li>
            <li><Link to="/ledger" className="text-slate-700 hover:text-orange-600" data-testid="footer-ledger">My ledger</Link></li>
            <li><Link to="/reading-tracker" className="text-slate-700 hover:text-orange-600" data-testid="footer-reading-tracker">Reading tracker</Link></li>
            <li><Link to="/pro" className="text-slate-700 hover:text-orange-600" data-testid="footer-pro">Pro Plan</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-slate-700 hover:text-orange-600" data-testid="footer-about">About us</Link></li>
            <li><Link to="/contact" className="text-slate-700 hover:text-orange-600" data-testid="footer-contact">Contact us</Link></li>
            <li><Link to="/feedback" className="text-slate-700 hover:text-orange-600" data-testid="footer-feedback">Share feedback</Link></li>
            <li><Link to="/faqs" className="text-slate-700 hover:text-orange-600" data-testid="footer-faqs">FAQs</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-3">Follow us</div>
          <a
            href="https://www.instagram.com/juniorshelf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-tr from-orange-500 via-rose-500 to-purple-600 text-white text-sm font-semibold hover:opacity-90 transition-opacity"
            data-testid="footer-instagram"
          >
            <Instagram size={16} strokeWidth={2.2} /> @juniorshelf
          </a>
          <div className="text-[11px] text-slate-500 mt-3 leading-relaxed">Little stories, new listings & bookish moments — daily on Instagram.</div>
        </div>
      </div>
      <div className="border-t border-amber-100 py-6 px-4 space-y-3">
        <div className="max-w-4xl mx-auto text-[11px] text-slate-500 leading-relaxed text-center" data-testid="footer-disclaimer">
          Junior Shelf is a peer-to-peer platform for sharing books among <b>neighbours</b>. We do not verify book condition,
          ownership, or availability, and make <b>no guarantee</b> on any listing. Please meet in <b>public places</b> and use
          common sense. All new listings are moderated for age-appropriate content.
        </div>
        <div className="text-center text-xs text-slate-500">
          © {new Date().getFullYear()} Junior Shelf · A Neighbourhood book library
        </div>
      </div>
    </footer>
  );
}
